import { render, staticRenderFns } from "./CashierInkass.vue?vue&type=template&id=055610e8&scoped=true&"
import script from "./CashierInkass.vue?vue&type=script&lang=js&"
export * from "./CashierInkass.vue?vue&type=script&lang=js&"
import style0 from "./CashierInkass.vue?vue&type=style&index=0&id=055610e8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055610e8",
  null
  
)

export default component.exports